export const SearchForm = ({ onSearch, isLoading }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const query = e.target.elements.searchQuery.value;
    if (query.trim()) {
      onSearch(query);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-2xl mx-auto mb-8">
      <div className="relative flex items-center shadow-sm bg-white border border-idc-border rounded-md overflow-hidden focus-within:ring-1 focus-within:ring-idc-red focus-within:border-idc-red transition-all">
        <input 
          type="text" 
          name="searchQuery"
          placeholder="Buscar nota (Ej: Violencia en tiendas...)"
          className="w-full px-6 py-4 text-idc-dark bg-transparent border-none outline-none text-base font-medium"
          required
          disabled={isLoading}
        />
        <button 
          type="submit" 
          className="px-8 py-4 bg-[#c8102e] hover:bg-[#9e0b22] text-white font-bold uppercase text-sm"
        >
          {isLoading ? 'Buscando...' : 'Consultar'}
        </button>
      </div>
    </form>
  );
};